import { render, staticRenderFns } from "./CreateTicketModal.vue?vue&type=template&id=b4fcbd90"
import script from "./CreateTicketModal.vue?vue&type=script&lang=js"
export * from "./CreateTicketModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports